import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import './comment.scss';

const Comment = props => (
  <div className="comment-wrapper mb-3">
    <div className="comment">
      <div className="comment-content">
        <p>{props.comment}</p>
      </div>
      <div className="comment-meta">
        <p className="subtext">
          by {props.author}
          {props.created_at && (
            <span>
              • <em>{moment.utc(props.created_at).fromNow()}</em>
            </span>
          )}
        </p>
      </div>
    </div>
  </div>
);

Comment.propTypes = {
  comment: PropTypes.string,
  author: PropTypes.string,
  created_at: PropTypes.string,
};

export default Comment;
